<template>
  <div
    v-if="defaultDeviceGroups.length > 0"
    data-test-id="DeviceGroupAssociations__container"
  >
    <hr :class="$style.hr">
    <HeadingExtraSmall
      :class="$style.header"
    >
      Device Group Associations
      <IconTooltip>
        You can change the default device group assigned to this device. See
        <ExternalLink
          :href="kbLink"
          text="Changing a Default Device Group."
        />
      </IconTooltip>
    </HeadingExtraSmall>
    <ParagraphBody
      v-for="defaultGroup in defaultDeviceGroups"
      :key="defaultGroup.name"
      bodySize="small"
    >
      <Icon
        :icon="defaultGroup.icon"
        inline
        :scale="1.25"
      />
      {{ defaultGroup.name }}
    </ParagraphBody>
  </div>
</template>

<script>
import {
  HeadingExtraSmall, Icon, ParagraphBody,
} from '@jumpcloud/ui-components';
import { isEmpty } from 'lodash';
import { mapActions, mapState } from 'vuex';
import DefaultDeviceGroupMixin from 'client/groups/System/mixins/DefaultDeviceGroupMixin';
import ExternalLink from 'client/components/ExternalLink.vue';
import IconTooltip from 'client/components/Tooltip/IconTooltip.vue';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';

const mdmSettingsModel = 'MdmSettingsModel';

export default {
  name: 'DeviceGroupAssociations',

  components: {
    ExternalLink,
    HeadingExtraSmall,
    Icon,
    ParagraphBody,
    IconTooltip,
  },

  mixins: [
    DefaultDeviceGroupMixin,
  ],

  data: () => ({
    kbLink: KbArticleUrls.changeDefaultDeviceGroup,
  }),

  computed: {
    ...mapState('SystemGroupModel', {
      item: 'item',
    }),

    defaultDeviceGroups() {
      const groupId = this.item.id;

      return this.getGroupTypeArray(groupId);
    },
  },

  mounted() {
    if (isEmpty(this.mdmSettings.mdmDevices)) {
      this.fetchMdmSettings();
    }
  },

  methods: {
    ...mapActions(mdmSettingsModel, [
      'fetchMdmSettings',
    ]),
  },
};
</script>
<style module>
.header {
  text-align: center;
}

.hr {
  border: 0;
  border-bottom: var(--jc-border-width) solid var(--jc-border-color-medium);
  margin: var(--jc-spacer) 0;
}
</style>
